<template>
  <div class="container u-flex-col u-col-center" v-cloak>
    <template v-if="applyDatas">
      <div class="top-con">
        <div class="tc-content u-flex">
          <div class="tcc-left u-flex-col u-flex-1">
            <p class="tccl-amount">总待还款金额</p>
            <p class="tccl-amount-1">{{ applyDatas.totalAmount }}</p>
            <p class="tccl-text">
              {{
                `${applyDatas.repayTypeTxt} 总利息${applyDatas.totalInterest}元`
              }}
            </p>
          </div>
          <div
            class="tcc-right u-flex-col u-col-center"
            @click="handleMakeCall"
          >
            <p class="tccr-phone">客服电话</p>
            <p class="tccr-phone_1">{{ phoneNumber }}</p>
          </div>
        </div>
      </div>

      <!-- 分期详情列表 -->
      <div class="bottom-con">
        <div
          class="bc-list u-flex"
          v-for="(i, idx) in applyDatas.plans"
          :key="idx"
        >
          <div class="bc-left">
            <p class="bcl-period">{{ i.periodTxt }}</p>
            <p class="bcl-date">{{ i.repayDate }}</p>
          </div>

          <div class="bc-center u-flex-col u-col-center">
            <div
              class="bcc-line u-flex-1"
              :style="{ opacity: idx === 0 ? 0 : 1 }"
            ></div>
            <img class="bcc-img" src="../../assets/images/img_know_6.png" />
            <div
              class="bcc-line u-flex-1"
              :style="{ opacity: idx === applyDatas.plans.length - 1 ? 0 : 1 }"
            ></div>
          </div>

          <div class="bc-right u-flex-1">
            <p class="bcr-text">{{ i.principal + i.interest }}</p>
            <p class="bcr-text-1">本金{{ i.principal }} 息费{{ i.interest }}</p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import * as API_Common from "@/api/common.js";

export default {
  name: "RepaymentPlan",
  data() {
    return {
      client: this.MixinClientBrowser(), // 设备
      phoneNumber: "95713",
      applyId: this.$route.query.applyId, // 计划ID
      applyDatas: null, // 还款计划集合
    };
  },
  mounted() {
    this.getApplyData();
  },
  methods: {
    // 获取还款计划信息
    getApplyData() {
      API_Common.getApplyData(this.applyId).then((res) => {
        if (res.code === 200) {
          this.applyDatas = res.data;
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },

    // 调用客户端拨打电话功能
    handleMakeCall() {
      const { client, phoneNumber } = this;
      if (client === "ios") {
        try {
          this.$bridge.callhandler("go2CallPhoneNum", { phoneNumber });
        } catch (err) {
          console.log("try---catch-调用IOS客户端方法报错");
        }
      } else if (client === "android") {
        if (window.LoanMarketChina) {
          try {
            window.LoanMarketChina.go2CallPhoneNum(phoneNumber);
          } catch (err) {
            console.log("try---catch-调用安卓客户端方法报错");
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #f4f4f4;
  padding-top: 0.5rem;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .bottom-con,
  .top-con {
    width: calc(100% - 0.6rem);
    margin: 0;
  }

  .top-con {
    background-image: url("../../assets/images/img_know_5.png");
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 0.36rem 0.41rem;

    .tc-content {
      .tcc-left {
        .tccl-amount {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 0.26rem;
          color: #101010;
          line-height: 0.4rem;
        }

        .tccl-amount-1 {
          font-family: Roboto;
          font-weight: normal;
          font-size: 0.6rem;
          color: #a8743e;
          line-height: 0.4rem;
          margin-top: 0.2rem;
          margin-bottom: 0.31rem;
        }

        .tccl-text {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 0.24rem;
          color: #a8743e;
          line-height: 0.4rem;
        }
      }

      .tcc-right {
        .tccr-phone {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 0.24rem;
          color: #a8743e;
          line-height: 0.4rem;
        }
        .tccr-phone_1 {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 0.36rem;
          color: #a8743e;
          line-height: 0.4rem;
        }
      }
    }
  }

  .bottom-con {
    background-color: #fff;
    border-radius: 0.1rem;
    padding: 0.08rem 0.4rem;

    .bc-list {
      // padding: 0.32rem 0rem;
      .bc-left {
        .bcl-period {
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 0.26rem;
          color: #101010;
          line-height: 0.4rem;
        }

        .bcl-date {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 0.24rem;
          color: #999999;
          line-height: 0.4rem;
          margin-top: 0.22rem;
        }
      }

      .bc-center {
        height: 1.6rem;
        width: 1rem;

        .bcc-line {
          width: 0.1px;
          height: 100%;
          background-color: #ededed;
        }

        .bcc-img {
          width: 0.2rem;
          height: 0.2rem;
        }
      }

      .bc-right {
        .bcr-text {
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 0.26rem;
          color: #101010;
          line-height: 0.4rem;
        }

        .bcr-text-1 {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 0.24rem;
          color: #999999;
          line-height: 0.4rem;
          margin-top: 0.22rem;
        }
      }
    }

    .van-cell-group--inset {
      margin: 0 0 0.32rem;
    }

    .van-cell__title {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: normal;
      color: #111c31;
    }

    .van-cell__label,
    .van-cell__value {
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      color: #868e9e;
    }

    .van-hairline--top-bottom::after {
      display: none;
    }

    .period-title {
      color: #3563fa;
    }
  }
}
</style>
